import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { Home } from "./page/Home/Home";
import "./App.css";
import { NotFound } from "./page/NotFound/NotFound";
import { Agreement } from "./page/Agreement/Agreement";
import { Policy } from "./page/Policy/Policy";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Layout = ({ children }) => {
  const location = useLocation();

  const hideNav = location.pathname === "/agreement" || "/policy";

  return (
    <>
      {!hideNav && <Navigation /> }
      {children}
    </>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home data={landingPageData} />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
